import styled from "styled-components"
import { mobile, mobilePortrait, tablet, smallScreen } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
    margin-top: 100px;
    min-height: 85vh;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${tablet({ marginTop: "80px"})}
    ${mobile({ marginTop: "60px", padding: "10px"})}
    ${mobilePortrait({ marginTop: "40px"})}
`

export const Message = styled.p`
    color: var(--secondary);
`

export const Title = styled.h1`
    font-size: var(--fontL);
    font-weight: 400;
`

export const Form = styled.form`
    width: 30%;
    min-width: 300px;
    padding: 20px;
    background-color: ${({ theme }) => theme.body};
    opacity: 0.8;

    display: flex;
    flex-direction: column;

    ${tablet({ padding: "15px", width: "60%" })}
    ${mobile({ padding: "10px", width: "80%" })}
`

export const Input = styled.input`
    flex: 1;
    min-width: 40%;
    margin: 20px 10px 10px 0px;
    padding: 10px;
    background-color: transparent;
    color: ${({ theme }) => theme.text};
    border: 1px solid var(--secondary);
    transition: all 0.5s ease;
    font-size: var(--fontM);

    :focus{
        border: 3px solid var(--secondary);
        outline: none;
    }

    ::placeholder { 
        color: ${({ theme }) => theme.text};
    }

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontS);
    }
`